<template>
    <div :class="namespaceClass()">
        <component
            :mwc-id="report.id"
            v-for="report in reportItemsModel"
            :key="report.id"
            :class="namespaceClass('__report-item')"
            :is="currentReportComponent(report)"
            v-bind="report"
            @report-status-change="handleReportStatusChanged(report, $event)"
        ></component>
    </div>
</template>

<script>
import ReportListItem from "./ReportListItem";
import CoverReport from "./CoverReport";
import InvestmentDetailsReport from "./InvestmentDetailsReport";
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import * as types from "@/store/mutation-types";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";

export default {
    name: "report-list-view",
    components: {
        CoverReport,
        ReportListItem,
        InvestmentDetailsReport
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    props: {
        reportItems: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            actualItems: [],
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            reportComponentMapping: {
                DEFAULT: ReportListItem.name,
                CoverPage: CoverReport.name,
                InvestmentDetail: InvestmentDetailsReport.name
            }
        };
    },
    computed: {
        loadedPortfoliosLength() {
            return this.$store.getters["investments/portfoliosLength"];
        },
        reportItemsModel() {
            return this.actualItems
                .filter(i => i.visible)
                .map(i => ({
                    id: i.reportId,
                    text: this.locale && this.locale.language && this.labeller.getLabel(i.labelId), // the translations are set in translation/unique in adminTool
                    checked: i.checked,
                    disabled: i.disabled,
                    reportSettings: i.settings
                }));
        }
    },
    methods: {
        checkVisibility(reportItems) {
            return reportItems.map(item => {
                const tempItem = { ...item };

                const onePortfolioValidation =
                    (tempItem.reportId === "PortfolioComparison" || tempItem.reportId === "DistributionWithdrawalComparison") &&
                    this.loadedPortfoliosLength === 1;

                const twoPortfoliosValidation = tempItem.reportId === "DistributionWithdrawal" && this.loadedPortfoliosLength === 2;

                if (onePortfolioValidation || twoPortfoliosValidation) {
                    tempItem.visible = false;
                }
                return tempItem;
            });
        },
        currentReportComponent(report) {
            return this.reportComponentMapping[report.id] || ReportListItem;
        },
        handleReportStatusChanged(report, e) {
            const newReportStatus = this.$store.state.reportSetting.reportOptions.map(r => {
                if (r.reportId === report.id) {
                    return {
                        ...r,
                        checked: e
                    };
                }
                return r;
            });
            this.$store.commit(`reportSetting/${types.SET_REPORT_OPTIONS}`, newReportStatus);
        }
    },
    watch: {
        reportItems: {
            handler: function() {
                this.actualItems = [...this.checkVisibility(this.reportItems)];
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.report-list-view {
    &__report-item {
        margin-bottom: 16px;
    }
}
</style>
